// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1VNWH","productName":"Table_productName__EL2MS"};